/* eslint-disable */
import { Box, TextField, MenuItem, Button, FormControl, styled, Card, useTheme, Typography, CircularProgress, Select, FormHelperText, Autocomplete } from "@mui/material";
import { useState } from "react";
import { validateString } from "../../utils/validations";
import countryList from "../../utils/countryCode.json";
import { useLazyQuery } from "@apollo/client";
import { searchRanking } from "../../gql/queries/keywordsRanking";
import { usePopup } from "../../context/commonPop";
import { popupType } from "../../common/constant";
import AddIcon from "@mui/icons-material/Add";
import { DatePickerRangeComponent } from "../Analytic-Dashboard/DatePickerRange";

const BoxWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  "& .MainHeadingWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
    gap: "15px",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
    },
    "& .MainHeading": {
      fontSize: "18px",
      fontWeight: 700,
      lineHeight: "1",
      color: theme.palette.text.primary,
      whiteSpace: "nowrap",
    },
    "& .projectName": {
      border: `1px solid ${theme.palette.primary.main}`,
      padding: "10px 15px",
      color: theme.palette.primary.main,
      borderRadius: "50px",
    },
    "& .DateFilterWrapper": {
      width: "100%",
    },
  },
  "& .SearchFilter": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
    },
    "& .MuiFormControl-root": {
      "@media screen and (max-width:600px)": {
        width: "100%",
      },
      "& label": {
        marginBottom: "0",
        top: "50%",
        transform: "translate(14px, -50%)",
        "&.MuiInputLabel-shrink": {
          top: "0",
          transform: "translate(14px, -9px) scale(0.75)",
        },
      },
      "& .MuiAutocomplete-root": {
        "& .MuiInputBase-root": {
          paddingTop: "4.5px",
          paddingBottom: "4.5px",
        },
      },
      "& .MuiFormHelperText-root": {
        position: "absolute",
        top: "40px",
        left: "0",
        color: "#FA896B",
      },
    },
    "& .SearchIcon": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      minWidth: "auto",
      padding: "11px 10px 9px",
      width: "170px",
      "@media screen and (max-width:600px)": {
        width: "100%",
      },
      "& .MuiCircularProgress-root": {
        color: "#fff",
      },
    },
  },
}));

const KeywordHeader = ({ rankingData, setRankingData, handleFetchData, handleDateRangeChange, startDate, endDate, projectName, domain, projectId }) => {
  const theme = useTheme();
  const [formState, setFormState] = useState({
    countryCode: { code: "US", label: "United States", phone: "1", geoId: "2840" },
    keyword: "",
    targetDomain: domain,
  });
  const { customPopupModel } = usePopup();
  const [errorState, setErrorState] = useState({
    countryCode: false,
    keyword: false,
    targetDomain: false,
  });
  const [loading, setloading] = useState(false);

  const [SEARCH_RANKING] = useLazyQuery(searchRanking, { fetchPolicy: "network-only" });

  const handleInputChange = e => {
    const { name, value } = e.target;

    const parsedValue = name === "countryCode" && value ? JSON.parse(value) : value;

    setFormState(prevState => ({
      ...prevState,
      [name]: parsedValue,
    }));

    if (name === "keyword" && !validateString(parsedValue)) {
      setErrorState(prevState => ({ ...prevState, keyword: false }));
    }

    if (name === "targetDomain" && !validateString(parsedValue)) {
      setErrorState(prevState => ({ ...prevState, targetDomain: false }));
    }

    if (name === "countryCode" && parsedValue?.code !== "DEFAULT") {
      setErrorState(prevState => ({ ...prevState, countryCode: false }));
    }
  };

  function checkError(item) {
    const keyword = validateString(item.keyword);
    const targetDomain = validateString(item.targetDomain);
    const countryCode = !item.countryCode || item.countryCode?.code === "DEFAULT";

    setErrorState({
      countryCode,
      keyword,
      targetDomain,
    });

    return keyword || targetDomain || countryCode;
  }

  function handleSubmit(e) {
    e.preventDefault();
    const check = checkError(formState);

    if (check) return;
    setloading(true);

    SEARCH_RANKING({
      variables: {
        getKeywordRankInput: {
          countryCode: formState.countryCode.code,
          geoId: Number(formState.countryCode.geoId),
          keywords: formState.keyword,
          targetDomain: formState.targetDomain,
          projectId,
        },
      },
      onCompleted: async ({ getSearchRank }) => {
        setloading(false);
        await handleFetchData();

        setRankingData(getSearchRank);
        customPopupModel({
          type: popupType.success,
          buttonType: popupType.success,
          contentFunc: <Typography component="p">Keywords added successfully</Typography>,
        });
      },
      onError: errdata => {
        setloading(false);
        customPopupModel({
          type: popupType.failed,
          buttonType: popupType.failed,
          contentFunc: <Typography component="p">{errdata.message}</Typography>,
        });
      },
    });
  }
  return (
    <BoxWrapper>
      <Card sx={{ padding: "16px 24px 24px 24px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }}>
        <Box className="MainHeadingWrapper">
          <Typography className="MainHeading" component="h2">
            Ranking details
          </Typography>
          {projectName && (
            <Typography className="MainHeading projectName" component="h2">
              {projectName}
            </Typography>
          )}
          <Box className="DateFilterWrapper">
            <DatePickerRangeComponent
              handleFetchData={handleFetchData}
              handleDateRangeChange={handleDateRangeChange}
              startDate={startDate}
              endDate={endDate}
              rankingData={rankingData}
            />
          </Box>
        </Box>
        <Box className="SearchFilter">
          <FormControl sx={{ flex: "1" }}>
            <Autocomplete
              options={countryList.filter(option => option.code !== "DEFAULT")}
              getOptionLabel={option => option?.label || ""}
              value={formState.countryCode || null}
              onChange={(event, newValue) => {
                handleInputChange({
                  target: {
                    name: "countryCode",
                    value: newValue ? JSON.stringify(newValue) : null,
                  },
                });
              }}
              isOptionEqualToValue={(option, value) => option?.code === value?.code}
              clearIcon={formState.countryCode?.code === "DEFAULT" ? null : undefined}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Select geo location
                  "
                  error={!!errorState.countryCode}
                />
              )}
            />

            {errorState.countryCode && <FormHelperText>Please select geo location</FormHelperText>}
          </FormControl>
          <FormControl sx={{ flex: "1" }}>
            <TextField
              id="targetDomain"
              name="targetDomain"
              value={formState.targetDomain}
              label="Enter domain"
              onChange={handleInputChange}
              required
              error={errorState.targetDomain}
              helperText={errorState.targetDomain && "Please enter domain"}
              disabled
            />
          </FormControl>
          <FormControl sx={{ flex: "1" }}>
            <TextField
              id="keyword"
              name="keyword"
              label="Enter comma separated keyword"
              variant="outlined"
              required
              value={formState.keyword}
              onChange={handleInputChange}
              error={errorState.keyword}
              helperText={errorState.keyword && "please enter keyword"}
            />
          </FormControl>
          <Button className="SearchIcon" type="submit" onClick={handleSubmit} disabled={loading}>
            {loading ? (
              <CircularProgress size={24} />
            ) : (
              <Typography component={"span"}>
                <AddIcon />
                Add keywords
              </Typography>
            )}
          </Button>
        </Box>
      </Card>
    </BoxWrapper>
  );
};

export default KeywordHeader;
